var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"w-full px-4"},[_c('div',{staticClass:"relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"},[_c('map-example')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }